/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBreweryTourTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBreweryTour,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Cheers to Good Times!",
    "Brewery Adventure Awaits!",
    "Let’s Taste Some Brews!",
  ],
  title: "Brewery Tour",
  description: "Organize a fun brewery tour.",
  longDescription:
    "Plan a day of tasting and learning about different beers. Choose a date, select the breweries to visit, and decide on transportation!",
  emoji: "🍻",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Brewery Tour",
          emoji: "🍻",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go on the brewery tour?",
          emoji: "📅",
          completeAction: {
            question: "Decide on which breweries to visit?",
            description: "Which breweries do we want to check out?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What breweries should we visit?",
                emoji: "🏭",
                completeAction: {
                  question: "Decide on transportation?",
                  description: "How should we get to the breweries?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What transportation should we use?",
                      emoji: "🚗",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Enjoy the Brews!",
    outroDescription:
      "Your brewery tour plans are set! Enjoy tasting and learning about beers!",
  },
};
